import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import { AgreementCompliancePageProps } from 'pages/allTasks/TaskModal/AgreementCompliancePageProps';
import TaskModalStepToggle from '../TaskModalStepToggle';

const QldAgreementDetails = ({
  task,
  taskNumber,
  toggleTaskStep,
}: AgreementCompliancePageProps) => {
  const agreementDetailsSteps = task.taskSteps ?? [];

  return (
    <AgxSpacer direction="vertical" gap="spacing-3xl" fill>
      <AgxTypography size="large" type="label" id="step1title" color="var(--text-primary)">
        {`Step ${taskNumber} : Agreement Compliance`}
      </AgxTypography>
      <AgxSpacer direction="vertical" gap="spacing-xl" fill>
        {agreementDetailsSteps.map((step) => (
          <TaskModalStepToggle key={step.order} step={step} toggleTaskStep={toggleTaskStep} large />
        ))}
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default QldAgreementDetails;
